import { faker } from '@faker-js/faker';
import { Provider } from '@types';

export default function getProviderFixture(
  params?: Partial<Provider>,
): Provider {
  return {
    id: faker.string.uuid(),
    firstName: faker.person.firstName(),
    imageUrl: faker.image.avatar(),
    lastName: faker.person.lastName(),
    prefix: 'Dr.',
    suffix: 'MD',
    ...params,
  };
}
